export const getBase64 = ({file, callback}) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => callback({result: reader.result})
  reader.onerror = error => callback({error})
}
